import React, {Component} from "react"
import {Row, Col} from "@irati/ui/src/Layout"

import Success from "@irati/ui/src/Success"
import DragAndDrop from "@irati/ui/src/DragAndDrop"
import {Team} from "@irati/types"
import {H2, H4, Body} from "@irati/ui/src/Typography"
import authentication from "@irati/auth"
import {injectIntl, InjectIntl} from "@irati/utils/lang"
import Loading from "@irati/ui/src/Loading"
import addUsersToTeamByCSV from "@irati/identity/utils/team/addUsersToTeamByCSV"

interface FailedUser {
  email: string
  message: string
}

interface Props extends InjectIntl {
  currentTeam: Team
  onHide: () => void
  show: boolean
}

interface State {
  load: Promise<any> | null
  show: boolean
  failedUsers: FailedUser[]
  saved: boolean
}

class BulkAddUsersToTeam extends Component<Props, State> {
  state: State = {
    load: null,
    saved: false,
    failedUsers: [],
    show: false
  }

  handleBulkUsers = (acceptedFiles: any) => {
    const {team, formatMessage} = this.props
    this.setState({
      failedUsers: [],
      saved: false
    })
    const load = addUsersToTeamByCSV(acceptedFiles[0], formatMessage, authentication.userTenant().uuid, team.uuid).then(
      ({failedUsers, saved}) => {
        if (this.props.onSubmit) this.props.onSubmit()
        this.setState({
          failedUsers,
          saved
        })
      }
    )
    this.setState({load})
  }

  render() {
    const {formatMessage} = this.props
    const {load, saved, failedUsers} = this.state

    if (saved && failedUsers.length === 0) {
      return <Success />
    }

    return (
      <>
        <H2 marginBottom={4}>{formatMessage({id: "admin.components.bulkAddUsersToTeam.title"})}</H2>
        <H4 marginBottom={4}>{formatMessage({id: "admin.components.bulkAddUsersToTeam.para"})}</H4>
        <Row>
          <Col md={12}>
            <DragAndDrop onDrop={this.handleBulkUsers} />
          </Col>
        </Row>
        <Loading load={load}>
          <Row>
            <Col md={8} mdOffset={2}>
              {saved && (
                <Body large maxWidth="100%" marginBottom={1}>
                  {formatMessage({id: "admin.components.bulkAddUsersToTeam.partSuccess"})}
                </Body>
              )}
              {failedUsers.length > 0 && (
                <>
                  <Body large maxWidth="100%" marginBottom={1}>
                    {formatMessage({id: "admin.components.bulkAddUsersToTeam.error"})}
                  </Body>
                  {failedUsers.map(({email, message}) => (
                    <Body small marginBottom={1}>
                      {email}: {message}
                    </Body>
                  ))}
                </>
              )}
            </Col>
          </Row>
        </Loading>
      </>
    )
  }
}

export default injectIntl(BulkAddUsersToTeam)
